export const ids = ['quantity', 'area', 'length', 'height', 'volume', 'coverage'] as const;
